import { useEffect } from 'react';

const ReCaptcha = ({ onVerify }) => {
  useEffect(() => {
    const handleReCaptcha = async () => {
      if (typeof window.grecaptcha === 'undefined') return;

      try {
        const token = await window.grecaptcha.enterprise.execute(
          process.env.REACT_APP_RECAPTCHA_SITE_KEY,
          { action: 'submit' }
        );

        onVerify(token);
      } catch (error) {
        console.error('reCAPTCHA error:', error);
      }
    };

    if (window.grecaptcha && window.grecaptcha.enterprise) {
      handleReCaptcha();
    } else {
      window.onLoadReCaptcha = handleReCaptcha;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;
    script.onload = () => {
      if (window.onLoadReCaptcha) {
        window.onLoadReCaptcha();
      }
    };
    document.head.appendChild(script);

    return () => {
      delete window.onLoadReCaptcha;
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [onVerify]);

  return null;
};

export default ReCaptcha;
